import PropTypes from 'prop-types';
import {useEffect, useRef, useState} from 'react';
import { useNavigate } from 'react-router';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, ButtonBase, CardContent, ClickAwayListener, Grid, Paper, Popper, Stack, Tab, Tabs, Tooltip, Typography } from '@mui/material';

// project import
import ProfileTab from './ProfileTab';
import Avatar from '../../../../../Components/@extended/Avatar';
import Transitions from '../../../../../Components/@extended/Transitions';
import IconButton from '../../../../../Components/@extended/IconButton';
import MainCard from '../../../../../Components/MainCard';

import { ThemeMode } from '../../../../../config';

import { useSelector} from "react-redux";

// assets
import avatar1 from '../../../../../assets/landing/genai343.jpg';
import { LogoutOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons';

// tab panel wrapper
function TabPanel({ children, value, index, ...other }) {
  return (
    <div role="tabpanel" hidden={value !== index} id={`profile-tabpanel-${index}`} aria-labelledby={`profile-tab-${index}`} {...other}>
      {value === index && children}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `profile-tab-${index}`,
    'aria-controls': `profile-tabpanel-${index}`
  };
}

const Profile = (props) => {
    const theme = useTheme();
    const LogoutButton = props.LogoutButton
    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);
    // const email = useSelector((state) => {
    // return state.authuser.username
    // });
    const {username, planName} = useSelector( (state) => state.authuser);
    const {selected_subscription} = useSelector((state) => state.xeroconnection);

    useEffect(() => {
        console.log(username);
    }
    );

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const [value, setValue] = useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const iconBackColorOpen = 'grey.200';

    return (
        <>
        <Box sx={{ flexShrink: 0, ml: 0.75 }}>
            <ButtonBase
                sx={{
                    p: 0.25,
                    bgcolor: open ? iconBackColorOpen : 'transparent',
                    borderRadius: 1,
                    '&:hover': { bgcolor: theme.palette.mode === ThemeMode.DARK ? 'secondary.light' : 'secondary.lighter' },
                    '&:focus-visible': {
                    outline: `2px solid ${theme.palette.secondary.dark}`,
                    outlineOffset: 2
                    }
            }}
                aria-label="open profile"
                ref={anchorRef}
                aria-controls={open ? 'profile-grow' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
            >
                <Stack direction="row" spacing={2} alignItems="center" sx={{ p: 0.5 }}>
                  <Avatar alt="profile user" src={avatar1} size="xs" />
                  <Typography variant="subtitle1" color="white">{username}</Typography>
                    <Typography variant="subtitle1" color="white">{selected_subscription?.plan_name}</Typography>
                    </Stack>
            </ButtonBase>
            <Popper
                placement="bottom-end"
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                popperOptions={{
                  modifiers: [
                    {
                      name: 'offset',
                      options: {
                        offset: [0, 9]
                      }
                    }
                  ]
                }}
              >
                {({ TransitionProps }) => (
                    <Transitions type="grow" position="top-right" in={open} {...TransitionProps}>
                        <Paper
                          sx={{
                            boxShadow: `0px 1px 1px rgb(0 0 0 / 14%), 0px 2px 1px rgb(0 0 0 / 12%), 0px 1px 3px rgb(0 0 0 / 20%)`,
                            width: 350,
                            minWidth: 240,
                            maxWidth: 350,
                            [theme.breakpoints.down('md')]: {
                              maxWidth: 250
                            }
                        }}
                        >
                            <ClickAwayListener onClickAway={handleClose}>
                                <MainCard elevation={0} border={false} content={false}>
                                    <CardContent sx={{ px: 2.5, pt: 3 }}>
                                        <Grid container justifyContent="space-between" alignItems="center">
                                            <Grid item>
                                                <Stack direction="row" spacing={1.25} alignItems="center">
                                                    <Avatar alt="profile user" src={avatar1} sx={{ width: 32, height: 32 }} />
                                                    <Stack>
                                                        <Typography variant="subtitle2">{username}</Typography>
                                                    </Stack>
                                                </Stack>
                                            </Grid>
                                            <Grid item>
                                                <LogoutButton />
                                            </Grid>
                                        </Grid>
                                    </CardContent>

                                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                        <Tabs variant="fullWidth" value={value} onChange={handleChange} aria-label="profile tabs">
                                            <Tab
                                                sx={{
                                                  display: 'flex',
                                                  flexDirection: 'row',
                                                  justifyContent: 'center',
                                                  alignItems: 'center',
                                                  textTransform: 'capitalize'
                                                }}
                                                icon={<UserOutlined style={{ marginBottom: 0, marginRight: '10px' }} />}
                                                label="Profile"
                                                {...a11yProps(0)}
                                              />
                                        </Tabs>
                                    </Box>
                                    <TabPanel value={value} index={0} dir={theme.direction}>
                                        <ProfileTab handleLogout={LogoutButton} />
                                    </TabPanel>

                                </MainCard>
                            </ClickAwayListener>
                        </Paper>
                        </Transitions>
                        )}
            </Popper>
        </Box>
        </>
    )

};

export default Profile;